// removed by extract-text-webpack-plugin
module.exports = {"root":"_3uCgSnu90xbBapxPrS1EWv","item":"wloAS-CbZ_fP7MfkLWMRe","active":"_3zTkIySz2mAS8YNZ7peSCN","fadeIn":"_2Lt__Rg0-OaYBDpkgK_tlD","indicators":"_3jTtkfzi66fVY6-_3nDMg5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/carousel.scss
// module id = 1502
// module chunks = 0